import { useState } from "react";
import { verifyPhoneNumber } from "@services/authenticationService";
import { useLoginGateway } from "@hooks/store";
import type { PhoneCredentials } from "./types";

type UseVerifyPhoneOptions = {
  onSuccess: () => void;
};

export function useVerifyPhone({ onSuccess }: UseVerifyPhoneOptions) {
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const loginGateway = useLoginGateway();

  const verify = async (phoneData: PhoneCredentials) => {
    setError("");
    setIsVerifying(true);
    try {
      const res = await verifyPhoneNumber(phoneData, loginGateway);
      if (res?.existingUser) {
        onSuccess();
      } else {
        setError("Not an existing user");
      }
    } catch {
      setError("Error verifying phone number");
    } finally {
      setIsVerifying(false);
    }
  };

  return { error, setError, isVerifying, verify };
}
